import React, { useEffect } from 'react';
import { ArrowLeft, DollarSign, CreditCard } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { API_URL } from "../../services/apiconfig";
import useAxiosInstance from '../../services/useAxiosInstance';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const loadPayPalScript = () => {
  return new Promise((resolve, reject) => {
    if (document.getElementById('paypal-js')) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = "https://www.paypal.com/sdk/js?client-id=AdJji2cGPBzWEFk6dpQppXP5eAXJ80rZ8AR4HuYbD5-yycag2OFgCx7rjasMfCY2iiCwujVN0xeh5hDu";
    script.id = 'paypal-js';
    script.onload = () => resolve(true);
    script.onerror = () => reject(false);
    document.body.appendChild(script);
  });
};

const PaymentPage = () => {
  const axiosInstance = useAxiosInstance();
  const communityId = useSelector((state) => state.auth.communityId);
  const clientId = useSelector((state) => state.auth.clientId);

  const location = useLocation();
  const { selectedPayments, totalAmount } = location.state || {
    selectedPayments: [],
    totalAmount: 0,
  };
  console.log(selectedPayments.map(payment => payment.paymentDetailId));
  const paymentDetailIds = selectedPayments.map(payment => payment.paymentDetailId);
  const amount = Number(totalAmount);

  useEffect(() => {
    loadPayPalScript().then(() => {
      if (window.paypal) {
        window.paypal.Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{ amount: { value: amount.toFixed(2) } }],
              application_context: {
                shipping_preference: 'NO_SHIPPING',
                user_action: 'PAY_NOW',
              },
              payer: {
                address: {
                  country_code: "US",
                }
              }
            });
          },
          onApprove: (data, actions) => {
            return actions.order.capture().then(async (details) => {
              try {
                alert(`Transaction completed by ${details.payer.name.given_name}`);

                const paymentLogData = {
                  paymentDetailIds: paymentDetailIds,
                  paymentLogDto: {
                    amount: parseInt(details.purchase_units[0].amount.value),
                    communityId: communityId,
                    createdDate: new Date().toISOString(),
                    paymentLogId: 0,
                    paymentStatus: details.status,
                    transactionId: details.id,
                    clientId: clientId
                  }
                };
                console.log(paymentLogData);

                const paymentBank = "PayPal";
                const paymentMethod = "PayPal";
                const paymentStatus = "Successfully";
                const paymentType = "Online";
                const formattedDate = new Date().toISOString().split("T")[0];

                // Use Promise.all to handle multiple async requests
                await Promise.all(paymentDetailIds.map(id => {
                  const params = {
                    paymentBank: paymentBank,
                    paymentDate: formattedDate,
                    paymentDetailId: id,
                    paymentMethod: paymentMethod,
                    paymentStatus: paymentStatus,
                    paymentType: paymentType
                  };

                  const url = `api/public/paymentdetail/updatePaymentDetail/${id}`;
                  return axiosInstance.patch(url, null, { params });
                }));

                console.log("All payment details updated successfully.");
                // Call handleCancel only after everything is done

              } catch (error) {
                console.error("Error processing payment:", error);
                // Optionally, handle error feedback to the user here
              }
            }).catch(err => {
              console.error("Error capturing order:", err);
              // Handle order capture error here
            });
          },

          onError: (err) => {
            console.error("Error during the payment:", err);
          },
        }).render('#paypal-button-container');
      }
    }).catch((error) => {
      console.error("PayPal script failed to load:", error);
    });
  }, [amount, paymentDetailIds, selectedPayments, axiosInstance]);

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <Link
            to='/payments-details'
            className="inline-flex items-center text-blue-500 hover:text-blue-700"
          >
            <ArrowLeft size={18} className="mr-1" />
            <span>Back to Payments</span>
          </Link>
        </div>

        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Payment Checkout</h1>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-2/3 p-6 border-r border-gray-200">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Payment Summary</h2>
              <div className="border border-gray-200 rounded-md overflow-hidden mb-4">
                <div className="bg-gray-50 px-4 py-3 flex justify-between border-b border-gray-200">
                  <span className="font-medium text-gray-700">PACKAGE</span>
                  <span className="font-medium text-gray-700">PRICE</span>
                </div>
                <div className="divide-y divide-gray-200">
                  {selectedPayments.map((item, index) => (
                    <div className="px-4 py-3 flex justify-between items-center" key={index}>
                      <span className="text-gray-700">{item.reason}</span>
                      <span className="text-gray-700">${item.amount.toFixed(2)}</span>
                    </div>
                  ))}
                </div>
                <div className="bg-gray-50 px-4 py-3 flex justify-between border-t border-gray-200">
                  <span className="font-medium text-gray-800">Total:</span>
                  <span className="font-bold text-gray-800">${totalAmount.toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/3 p-6 bg-gray-50">
              <div className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Checkout</h2>
                <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                  <span className="text-gray-700">Total Amount:</span>
                  <span className="text-lg font-bold text-gray-800">${totalAmount.toFixed(2)}</span>
                </div>
                <div className="pt-4">
                  <div id="paypal-button-container" className="mt-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentPage;